import { useAuth as useSupabaseAuth } from '@/contexts/AuthContext';

export function useAuth() {
  const { user, isReady, signIn, signOut, signUp, signInWithMagicLink, resetPassword, updatePassword, session } = useSupabaseAuth();
  
  return {
    // Backward compatibility - map new API to old API
    user,
    isLoading: !isReady,
    loading: !isReady,
    isAuthenticated: !!user,
    
    // Also expose new Supabase auth methods
    signIn,
    signOut,
    signUp,
    signInWithMagicLink,
    resetPassword,
    updatePassword,
    session,
  };
}
